const USER_ID_KEY = 'userId';

/**
 * localStorage에서 userId를 가져옵니다.
 */
export const getUserId = (): string | null => {
  return localStorage.getItem(USER_ID_KEY);
};

/**
 * localStorage에 userId를 저장합니다.
 */
export const setUserId = (userId: string): void => {
  localStorage.setItem(USER_ID_KEY, userId);
};

/**
 * localStorage에서 userId를 삭제합니다.
 */
export const removeUserId = (): void => {
  localStorage.removeItem(USER_ID_KEY);
};

/**
 * userId가 존재하는지 확인합니다.
 */
export const hasUserId = (): boolean => {
  return getUserId() !== null;
};


